import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const usePreloadImagesEffect = (images) => {
    useEffectWithErrorLogging(() => {
        images.forEach((image) => {
            const img = new window.Image();
            img.src = image;
            window[image] = img;
        });
    }, [images]);
};

export default usePreloadImagesEffect;
